import { createBrowserRouter, RouterProvider } from "react-router-dom";
import axios from "axios";
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { Root } from "./pages/root/Root";
import { Login } from "./pages/login/Login";
import { Level1 as PathmaticsLevel1 } from "./pages/pathmatics/level1/Level1";
import { Level2 as PathmaticsLevel2 } from "./pages/pathmatics/level2/Level2";
import { Level3 as PathmaticsLevel3 } from "./pages/pathmatics/level3/Level3";
import { Level1 as BisLevel1 } from "./pages/bis/level1/Level1";
import { Level2 as BisLevel2 } from "./pages/bis/level2/Level2";
import { Level3 as BisLevel3 } from "./pages/bis/level3/Level3";
import { MonitoringView } from "./pages/bis/monitoringView/MonitoringView";
import { MappingsView } from "./pages/selfPromotion/mappingsView/MappingsView";
import { Media } from "./pages/media/Media";
import { ProviderWorkflowMonitoringPage } from "./pages/media/providerWorkflowMonitoring/ProviderWorkflowMonitoringPage";
import { DataIngestion } from "./pages/audience/dataIngestion/DataIngestion";
import { MediaClassification } from "./pages/audience/mediaClassification/MediaClassification";
import { Level1 as ERetailLevel1 } from "./pages/eRetail/level1/Level1";
import { Level2 as ERetailLevel2 } from "./pages/eRetail/level2/Level2";
import { Level3 as ERetailLevel3 } from "./pages/eRetail/level3/Level3";
import { Level3DT as ERetailLevel3DT } from "./pages/eRetail/level3DT/Level3DT";
import { Spends } from "./pages/eRetail/spends/Spends";
import { Level2 as CtvLevel2 } from "./pages/ctv/level2/Level2";
import { Level3 as CtvLevel3 } from "./pages/ctv/level3/Level3";
import { Admin } from "./pages/admin/Admin";
import {
  ROUTE_LOGIN,
  ROUTE_ADMIN,
  ROUTE_MAIN,
  API_ROUTE_USER,
  ROUTE_PATHMATICS_LEVEL1,
  ROUTE_PATHMATICS_LEVEL2,
  ROUTE_PATHMATICS_LEVEL3,
  ROUTE_BIS_LEVEL1,
  ROUTE_BIS_LEVEL2,
  ROUTE_BIS_LEVEL3,
  ROUTE_BIS_MONITORING,
  ROUTE_MAPPINGS_VIEW,
  ROUTE_ALL_MAPPINGS_MEDIA,
  ROUTE_PROVIDER_WORKFLOW_MONITORING,
  ROUTE_DATA_INGESTION,
  ROUTE_MEDIA_CLASSIFICATION,
  ROUTE_E_RETAIL_LEVEL1,
  ROUTE_E_RETAIL_LEVEL2,
  ROUTE_E_RETAIL_LEVEL3,
  ROUTE_E_RETAIL_LEVEL3_DT,
  ROUTE_E_RETAIL_SPENDS,
  ROUTE_CTV_LEVEL2,
  ROUTE_CTV_LEVEL3,
} from "./routes";
import { theme } from "./theme";
import { debug } from "./utils/helpers";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

const rootLoader = async () => {
  return axios
    .get(API_ROUTE_USER)
    .then((resp) => {
      localStorage.setItem("sessionEnd", resp.data.expirationDateTime);
      debug.info("Session ends at", resp.data.expirationDateTime);
      return resp.data;
    })
    .catch(() => null);
};

const router = createBrowserRouter([
  {
    id: "root",
    path: ROUTE_MAIN,
    element: <Root />,
    loader: rootLoader,
    children: [
      {
        index: true,
        element: <PathmaticsLevel1 />,
      },
      {
        path: ROUTE_PATHMATICS_LEVEL1,
        element: <PathmaticsLevel1 />,
      },
      {
        path: ROUTE_PATHMATICS_LEVEL2,
        element: <PathmaticsLevel2 />,
      },
      {
        path: ROUTE_PATHMATICS_LEVEL3,
        element: <PathmaticsLevel3 />,
      },
      {
        path: ROUTE_BIS_LEVEL1,
        element: <BisLevel1 />,
      },
      {
        path: ROUTE_BIS_LEVEL2,
        element: <BisLevel2 />,
      },
      {
        path: ROUTE_BIS_LEVEL3,
        element: <BisLevel3 />,
      },
      {
        path: ROUTE_BIS_MONITORING,
        element: <MonitoringView />,
      },
      {
        path: ROUTE_MAPPINGS_VIEW,
        element: <MappingsView />,
      },
      {
        path: ROUTE_ALL_MAPPINGS_MEDIA,
        element: <Media />,
      },
      {
        path: ROUTE_PROVIDER_WORKFLOW_MONITORING,
        element: <ProviderWorkflowMonitoringPage />,
      },
      {
        path: ROUTE_DATA_INGESTION,
        element: <DataIngestion />,
      },
      {
        path: ROUTE_MEDIA_CLASSIFICATION,
        element: <MediaClassification />,
      },
      {
        path: ROUTE_E_RETAIL_LEVEL1,
        element: <ERetailLevel1 />,
      },
      {
        path: ROUTE_E_RETAIL_LEVEL2,
        element: <ERetailLevel2 />,
      },
      {
        path: ROUTE_E_RETAIL_LEVEL3,
        element: <ERetailLevel3 />,
      },
      {
        path: ROUTE_E_RETAIL_LEVEL3_DT,
        element: <ERetailLevel3DT />,
      },
      {
        path: ROUTE_E_RETAIL_SPENDS,
        element: <Spends />,
      },
      {
        path: ROUTE_CTV_LEVEL2,
        element: <CtvLevel2 />,
      },
      {
        path: ROUTE_CTV_LEVEL3,
        element: <CtvLevel3 />,
      },
      {
        path: ROUTE_LOGIN,
        element: <Login />,
      },
      {
        path: ROUTE_ADMIN,
        element: <Admin />,
      },
    ],
  },
]);

function App() {
  return (
    <CssVarsProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </CssVarsProvider>
  );
}

export default App;
